import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type DisconnectedCallRequest = void;

export interface DisconnectedCallRepository {
  getCurrentCall(): Promise<Call>;
  removeCalls(): Promise<void>;
}

export interface DisconnectedCallEventPublisher {
  publish(call: Call): Promise<void>;
}

export interface DisconnectedCallParticipantRepository {
  clearParticipants(): Promise<void>;
  clearExternalParticipant(): Promise<void>;
}

export interface DisconnectedCallUsecase
  extends BaseUsecase<DisconnectedCallRequest, void> {
  run(call: DisconnectedCallRequest): Promise<void>;
}

export class DisconnectedCall implements DisconnectedCallUsecase {
  constructor(
    private repository: DisconnectedCallRepository,
    private publisher: DisconnectedCallEventPublisher,
    private participantRepository: DisconnectedCallParticipantRepository,
  ) {}

  async run(): Promise<void> {
    const call = await this.repository.getCurrentCall();
    await this.participantRepository.clearParticipants();
    await this.participantRepository.clearExternalParticipant();
    await this.repository.removeCalls();

    if (call) {
      await Promise.all([this.publisher.publish(call)]);
    }
  }
}
